import { useState, useEffect } from "react";
// Composant Parrainages - Version mobile
export const ReferralsContent = () => {
    const [filterType, setfilterType] = useState('date');
    const [history, setHistory] = useState([
        // {
        //     date: "2025-08-28",
        //     user: "Marie D.",
        //     level: 1,
        //     amount: 1400,
        //     amountColor: "text-green-600",
        //     status: "Payé",
        //     statusColor: "bg-green-100 text-green-800"
        // },
        // {
        //     date: "2025-08-27",
        //     user: "Paul K.",
        //     level: 2,
        //     amount: 600,
        //     amountColor: "text-blue-600",
        //     status: "Payé",
        //     statusColor: "bg-green-100 text-green-800"
        // },
        // {
        //     date: "2025-08-26",
        //     user: "Jean B.",
        //     level: 1,
        //     amount: 1500,
        //     amountColor: "text-orange-600",
        //     status: "En cours",
        //     statusColor: "bg-orange-100 text-orange-800"
        // },
        // {
        //     date: "2025-08-26",
        //     user: "z",
        //     level: 3,
        //     amount: 1400,
        //     amountColor: "text-orange-600",
        //     status: "En cours",
        //     statusColor: "bg-orange-100 text-orange-800"
        // }
    ]
    );

    const [userData, setUserData] = useState({
        link: "",
        name: "",
        balance: 0,
        totalEarnings: 0,
        referred: {
            level1: 0,
            level2: 0,
            level3: 0
        },
        gain: 0,
        gainTaches: 0,
        pendingWithdrawals: 0
    });


    // console.log()d

    useEffect(() => {
        const rawUser = localStorage.getItem("user");
        if (!rawUser) return;

        const user = JSON.parse(rawUser);

        let level1 = 0;
        let level2 = 0;
        let level3 = 0;

        const computedHistory = [];

        // Mapping niveau -> montant
        const levelAmountMap = {
            1: 1400,
            2: 600,
            3: 300
        };

        // Mapping statut -> couleurs
        const statusStyles = {
            "Payé": {
                amountColor: "text-green-600",
                statusColor: "bg-green-100 text-green-800"
            },
            "En cours": {
                amountColor: "text-orange-600",
                statusColor: "bg-orange-100 text-orange-800"
            },
            "pending": {
                amountColor: "text-gray-600",
                statusColor: "bg-gray-100 text-gray-800"
            }
        };

        if (Array.isArray(user.referred)) {
            user.referred.forEach(ref => {
                // console.log(user)
                // Comptage des niveaux
                if (ref.level === 1) level1++;
                if (ref.level === 2) level2++;
                if (ref.level === 3) level3++;

                // On récupère l'utilisateur complet si popule
                const referredUser = ref.user || {};

                // Statut basé sur isActive
                const status = referredUser.isActive ? "Payé" : "En cours";
                const styles = statusStyles[status] || statusStyles.pending;

                // Date format safe
                const createdAt = referredUser.createdAt ? new Date(referredUser.createdAt) : null;
                const formattedDate = (createdAt && !isNaN(createdAt)) ? createdAt.toISOString().split("T")[0] : "--";

                // Historique
                computedHistory.push({
                    date: formattedDate,
                    user: `${referredUser.firstname || ""} ${referredUser.lastname?.[0] || ""}.`,
                    level: ref.level,
                    amount: levelAmountMap[ref.level] || 0,
                    amountColor: styles.amountColor,
                    status,
                    statusColor: styles.statusColor
                });
            });
        }

        // Mise à jour userData
        setUserData(prev => ({
            ...prev,
            ...user,
            link: user.referralLink || "",
            referred: {
                level1,
                level2,
                level3
            }
        }));

        // Mise à jour history
        setHistory(computedHistory);

    }, []);





    const sortByDate = (a, b) => {
        return (new Date(b.date)) - (new Date(a.date));
    };

    const sortByUsername = (a, b) => {
        if (a.user.toLowerCase() < b.user.toLowerCase()) return -1;
        else if (a.user.toLowerCase() > b.user.toLowerCase()) return 1;
        else return 0;
    }

    const sortByLevel = (a, b) => a.level - b.level;

    const sortByAmount = (a, b) => a.amount - b.amount;

    const sortByStatus = (a, b) => {
        if (a.status === "Payé" && b.status === "En cours") return -1;
        else if (b.status === "Payé" && a.status === "En cours") return 1;
        else return 0;
    }


    let filteredHistory = [...history].sort((a, b) => {
        if (!filterType) return 0;
        if (filterType === "date") return sortByDate(a, b);
        if (filterType === "user") return sortByUsername(a, b);
        if (filterType === "level") return sortByLevel(a, b);
        if (filterType === "amount") return sortByAmount(a, b);
        if (filterType === "status") return sortByStatus(a, b);

        return 0; // <-- indispensable
    });


    return (
        <div className="space-y-4 pb-20">
            {/* Cards des niveaux - Responsive */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
                <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                    <div className="flex items-center md:flex-col md:text-center">
                        <div className="text-3xl md:text-4xl mr-4 md:mr-0 md:mb-2">🥇</div>
                        <div className="flex-1 md:flex-none">
                            <h3 className="text-base md:text-lg font-semibold text-gray-800">Niveau 1</h3>
                            <p className="text-xl md:text-3xl font-bold text-green-600">{userData.referred.level1}</p>
                            <p className="text-xs md:text-sm text-gray-600">1400F/parrainage</p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                    <div className="flex items-center md:flex-col md:text-center">
                        <div className="text-3xl md:text-4xl mr-4 md:mr-0 md:mb-2">🥈</div>
                        <div className="flex-1 md:flex-none">
                            <h3 className="text-base md:text-lg font-semibold text-gray-800">Niveau 2</h3>
                            <p className="text-xl md:text-3xl font-bold text-blue-600">{userData.referred.level2}</p>
                            <p className="text-xs md:text-sm text-gray-600">600F/parrainage</p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                    <div className="flex items-center md:flex-col md:text-center">
                        <div className="text-3xl md:text-4xl mr-4 md:mr-0 md:mb-2">🥉</div>
                        <div className="flex-1 md:flex-none">
                            <h3 className="text-base md:text-lg font-semibold text-gray-800">Niveau 3</h3>
                            <p className="text-xl md:text-3xl font-bold text-purple-600">{userData.referred.level3}</p>
                            <p className="text-xs md:text-sm text-gray-600">300F/parrainage</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Historique */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                <h3 className="text-lg md:text-xl font-bold mb-4">Historique</h3>

                {/* Table mobile - Cards */}
                <div className="space-y-3 md:hidden">
                    <div>
                        <label htmlFor="history">Trier par: </label>
                        <div className="border w-min inline">
                            <select onChange={(e) => setfilterType(e.target.value)} id="history" className="text-sm text-gray-500">
                                <option value="">--Choisir un critère--</option>
                                <option value="date">Date de parrainage</option>
                                <option value="user">Utilisateur</option>
                                <option value="level">Niveau</option>
                                <option value="amount">Commission</option>
                                <option value="status">Statut</option>
                            </select>
                            {/* <span className="font-bold">Value: {filterType}</span> */}
                        </div>
                        <div className="flex flex-col w-min gap-2 my-2 md:inline">
                            {filterType === "date" && <input type="date" max={new Date().toISOString().split("T")[0]} className=" hidden text-blue-500 text-sm font-semibold"></input>}
                            {filterType === "user" && <input placeholder="Marie KOUASSI..." type="text" className="px-1 border hidden text-blue-500 text-sm"></input>
                            }
                            {filterType === "level" && <select className="box text-sm hidden text-blue-500 border">
                                <option value="1">Niveau 1</option>
                                <option value="2">Niveau 2</option>
                                <option value="3">Niveau 3</option>
                            </select>}

                            {filterType === "amount" && <select className="hidden box text-sm  text-blue-500 border">
                                <option value="1">300</option>
                                <option value="2">600</option>
                                <option value="3">1400</option>
                            </select>}
                            {filterType === "status" && <select className="hidden box text-sm  text-blue-500 border">
                                <option value="1">En cours</option>
                                <option value="2">Payé</option>
                            </select>}
                        </div>

                    </div>
                    {filteredHistory.map((h, i) => (
                        <div key={i} className="border rounded-lg p-3 bg-gray-50">
                            <div className="flex justify-between items-start mb-2">
                                <div>
                                    <p className="font-medium text-gray-800">{h.user}</p>
                                    <p className="text-sm text-gray-600">{h.date}</p>
                                </div>
                                <span className={`${h.statusColor} px-2 py-1 rounded text-xs`}>{h.status}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-sm text-gray-600">{"Niveau " + h.level}</span>
                                <span className={`${h.amountColor} font-semibold`}>{h.amount}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Table desktop */}
                <div className="hidden md:block overflow-x-auto">
                    <div>
                        <label htmlFor="history">Trier par: </label>
                        <div className="border w-min inline-block">
                            <select onChange={(e) => setfilterType(e.target.value)} id="history" className="text-sm text-gray-500">
                                <option value="">--Choisir un critère--</option>
                                <option value="date">Date de parrainage</option>
                                <option value="user">Utilisateur</option>
                                <option value="level">Niveau</option>
                                <option value="amount">Commission</option>
                                <option value="status">Statut</option>
                            </select>
                            {/* <span className="font-bold">Value: {filterType}</span> */}
                        </div>

                        {/* TRI A PARTIR DE VALEURS PRECISES */}

                        {/* <div className="flex flex-col w-min gap-2 my-2">
                            {filterType === "date" && <input type="date" max={new Date().toISOString().split("T")[0]} className="text-blue-500 text-sm font-semibold"></input>}
                            {filterType === "user" && <input placeholder="Marie KOUASSI..." type="text" className="px-1 border text-blue-500 text-sm"></input>
                            }
                            {filterType === "level" && <select className="box text-sm  text-blue-500 border">
                                <option value="1">Niveau 1</option>
                                <option value="2">Niveau 2</option>
                                <option value="3">Niveau 3</option>
                            </select>}

                            {filterType === "amount" && <select className="box text-sm  text-blue-500 border">
                                <option value="1">300</option>
                                <option value="2">600</option>
                                <option value="3">1400</option>
                            </select>}
                            {filterType === "status" && <select className="box text-sm  text-blue-500 border">
                                <option value="1">En cours</option>
                                <option value="2">Payé</option>
                            </select>}
                        </div> */}

                    </div>
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b">
                                <th className="text-left py-2">Date</th>
                                <th className="text-left py-2">Utilisateur</th>
                                <th className="text-left py-2">Niveau</th>
                                <th className="text-left py-2">Commission</th>
                                <th className="text-left py-2">Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredHistory.map((h, i) => (
                                <tr key={i} className="border-b">
                                    <td className="py-2">{h.date}</td>
                                    <td className="py-2">{h.user}</td>
                                    <td className="py-2">{h.level}</td>
                                    <td className={`py-2 ${h.amountColor} font-semibold`}>{h.amount}</td>
                                    <td className="py-2">
                                        <span className={`${h.statusColor} px-2 py-1 rounded text-xs`}>
                                            {h.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>
            {/* Liste de parrainés */}

        </div >
    )
};